import $ from 'jquery';
import Cookies from 'js-cookie';
require('normalize.css/normalize.css');
require('../css/main.scss');
import 'regenerator-runtime/runtime';
import { db, getDoc, doc, auth, registerUser, getCompanyByName, createCompany, serverTimestamp, onAuthStateChanged, signOutUser, addDoc, collection, updateDoc, setDoc, query, where, getDocs, orderBy, limit, onSnapshot, writeBatch, httpsCallable, functions } from '../js/firebaseConfig';
import { checkAuthAndRedirect } from '../js/redirect.js';

$(document).ready(function() {
  /**********
   * 
   * 
   * 
   * 
   * DEMO ASSESSMENT 
   * 
   * 
   * 
   * 
   * **********/
  $('.trophy').on('click', function() {
    var $trophy = $(this);
    $trophy.addClass('vibrate');
    setTimeout(function() {
        $trophy.removeClass('vibrate');
    }, 300);
  });

  function formatTime(timestamp) {
    const date = new Date(timestamp);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }
  function formatDuration(durationString) {
    const durationMinutes = parseInt(durationString, 10);
    return durationMinutes;
  }
  window.addEventListener('message', async (event) => {
    if (event.origin === 'https://tally.so') {
      try {
        if (!event.data.startsWith('{')) {
          return;
        }
        const eventData = JSON.parse(event.data);
        if (eventData.event === 'Tally.FormSubmitted') {
          var formData = eventData.payload;
          var filteredData = formData.fields.filter(field => 
            field.title === 'Votre email professionnel' ||
            field.title === 'Nom de votre entreprise'
          );
          var filteredDataObject = {};
          filteredData.forEach(field => {
            if (field.title === 'Votre email professionnel') {
              filteredDataObject.email = field.answer.value;
            } else if (field.title === 'Nom de votre entreprise') {
              filteredDataObject.company = field.answer.value;
            }
          });
          Cookies.set('formData', JSON.stringify(filteredDataObject), {
            path: '/',
            sameSite: 'Lax',
            secure: false,
            expires: 1
          });
          onAuthStateChanged(auth, (user) => {
            window.location.href = 'https://www.salesridge.co/demo/assessment.html';
          });
        }
      } catch (error) {
        console.error('Erreur lors de l\'analyse des données de l\'événement:', error);
      }
    }
    if (event.origin === 'https://meetings-eu1.hubspot.com') {
      try {
        const eventData = event.data;
        if (eventData.meetingBookSucceeded) {
          const meetingsPayload = eventData.meetingsPayload;
          const bookingResponse = meetingsPayload.bookingResponse;
          const eventDetails = bookingResponse.event;
          const companyId = Cookies.get('companyId');
          async function addAppointment() {
            try {
              const appointmentRef = await addDoc(collection(db, 'appointments'), {
                companyId: companyId,
                date: eventDetails.dateString,
                duration: formatDuration(eventDetails.duration),
                time: formatTime(eventDetails.dateTime)
              });
              $('<div class="notificationsRDV"><p>Rendez-vous pris avec succès.</p></div>').prependTo('body .plan');
              $('body').removeClass('bookMeeting');
            } catch (e) {
              console.error("Error adding document: ", e);
            }
          }
          await addAppointment();
        }
      } catch (error) {
        console.error('Erreur lors de la conversion du message en JSON:', error);
      }
    }
  });
  $(document).on("click", "#startAssessment", function() {
    $('body').addClass('startAssessment');
  });
  //MOBILE
  $('#mobileMenu').on('click', function() {
    event.preventDefault();
    $('body').addClass('navOpen');
  });
  $('#navBackground').on('click', function() {
    event.preventDefault();
    $('body').removeClass('navOpen');
  });
  //HUBSPOT
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.id = 'hs-script-loader';
  script.async = true;
  script.defer = true;
  script.src = '//js.hs-scripts.com/26298630.js';
  $('body').append(script);
  //TABS
  $('.tab-links a').on('click', function(e) {
    e.preventDefault();
    var tabId = $(this).attr('href');
    $('.tab-links li, .tab').removeClass('active');
    $(this).parent('li').addClass('active');
    $(tabId).addClass('active');
  });
  $(document).on('click', '.tab-links2 a', async function(e) {
    e.preventDefault();
    var tabId = $(this).attr('href');
    $('.tab-links2 li, .tab2').removeClass('active');
    $(this).parent('li').addClass('active');
    $(tabId).addClass('active');
  });
  //STATUSSEQUENCESMODAL
  $(".statusSequencesModal input").on("keyup", function() {
    let searchText = $(this).val().toLowerCase();
    $(".statusSequencesModal p").each(function() {
        let text = $(this).text().toLowerCase();
        if (text.includes(searchText)) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });
  });
  $(document).on("click", function(event) {
    if (!$(event.target).closest(".statusSequencesModal, .statusSequences").length) {
      $(".statusSequencesModal").removeClass("active");
      $(".statusSequencesModal input").val('');
      $(".statusSequencesModal p").each(function() {
        $(this).show();
      });
    }
  });
  $(document).on('click', '.statusSequences', async function(event) {
    $(".statusSequencesModal input").val('');
    $(".statusSequencesModal p").each(function() {
      $(this).show();
    });
    let modal = $(".statusSequencesModal");
    let windowHeight = $(window).height();
    let windowWidth = $(window).width();
    let modalHeight = modal.outerHeight();
    let modalWidth = modal.outerWidth();
    let clickX = event.pageX;
    let clickY = event.pageY;

    let posX = clickX;
    let posY = clickY;

    // GESTION DU POSITIONNEMENT VERTICAL
    if (clickY + modalHeight > windowHeight - 20) { 
        posY = clickY - modalHeight - 10;
    } else { 
        posY = clickY + 10;
    }

    // GESTION DU POSITIONNEMENT HORIZONTAL
    if (clickX + modalWidth > windowWidth - 20) { 
        posX = clickX - modalWidth - 10;
    } else { 
        posX = clickX + 10;
    }

    // Associer la modal au bon élément cliqué
    modal.data("target", $(this));

    modal.css({
        "top": posY + "px",
        "left": posX + "px",
    }).addClass("active");
  });
  

  $(document).on("click", ".statusSequencesModal p", async function () {
    let newStatusText = $(this).text().trim(); 
    let newStatus = $(this).attr('data-value'); 
    let target = $(".statusSequencesModal").data("target");

    if (!target) {
        console.error("❌ Erreur : aucun élément statusSequences associé à la modal.");
        return;
    }

    let leadId = target.data("lead");
    let campaignId = target.data("campaign");
    let stepIndex = target.data("step");

    if (!leadId || !campaignId || stepIndex === undefined) {
        console.error("❌ Erreur : Données manquantes (leadId, campaignId ou stepIndex)");
        return;
    }

    target.text(newStatusText).removeClass().addClass(`statusSequences ${newStatusText}`);

    const leadRef = doc(db, "leads", leadId);
    getDoc(leadRef)
        .then((leadSnap) => {
            if (leadSnap.exists()) {
                let leadData = leadSnap.data();
                
                if (leadData.campaigns && leadData.campaigns[campaignId] && Array.isArray(leadData.campaigns[campaignId].steps)) {
                    let steps = leadData.campaigns[campaignId].steps;

                    if (steps[stepIndex]) {
                        steps[stepIndex].status = newStatus;
                        updateDoc(leadRef, {
                            [`campaigns.${campaignId}.steps`]: steps
                        }, { merge: true })
                        .then(() => {
                            console.log(`✅ Statut mis à jour : ${newStatus}`);
                        })
                        .catch((error) => {
                            console.error("❌ Erreur de mise à jour Firestore :", error);
                        });
                    } else {
                        console.error("❌ Erreur : Step index non trouvé.");
                    }
                } else {
                    console.error("❌ Erreur : Campagne ou steps non trouvés.");
                }
            }
        })
        .catch((error) => {
            console.error("❌ Erreur de récupération du lead :", error);
        });

    // Fermer la modal après mise à jour
    $(".statusSequencesModal").removeClass("active");
  });
});


//NOTIFICATIONS
/**
// Système de notifications Firestore en temps réel
function initNotificationsSystem() {
  console.log('🚀 Initialisation du système de notifications...');
  // Vérifier si l'utilisateur est connecté
  onAuthStateChanged(auth, async (user) => {
    if (user) {
      console.log('👤 Utilisateur connecté:', user.email);
      // Récupérer l'ID de l'entreprise de l'utilisateur
      var companyId = Cookies.get('companyId');
      const userAdmin = Cookies.get('admin');
      if (!userAdmin) {
        if (!companyId) {
          console.error('❌ Aucun ID d\'entreprise trouvé, notifications désactivées');
          return;
        }
        listenForNotifications(companyId);
        console.log('🏢 ID de l\'entreprise:', companyId);
      }
      else{
        companyId = 'admin';
        listenForNotifications(companyId);
      }
    } else {
      console.log('❌ Aucun utilisateur connecté, notifications désactivées');
    }
  });
}
function listenForNotifications(companyId) {
  console.log('👂 Démarrage de l\'écoute des notifications pour la compagnie:', companyId);
  // Créer une requête pour récupérer les notifications de l'entreprise
  let notificationsQuery;
  
  if (companyId === 'admin') {
    notificationsQuery = query(
      collection(db, 'notifications'),
      where('adminMode', '==', true),
      orderBy('timestamp', 'desc')
    );
  }
  else{
    notificationsQuery = query(
      collection(db, 'notifications'),
      where('companyId', '==', companyId),
      orderBy('timestamp', 'desc')
    );
  }
  let processedToasts = new Set();
  
  // Écouter les changements en temps réel
  onSnapshot(notificationsQuery, (snapshot) => {
    console.log(`📊 ${snapshot.size} notifications trouvées dans Firestore`);
    
    const $notificationsContainer = $('#notificationsContainer');
    if ($notificationsContainer.length === 0) {
      console.error('❌ Container de notifications non trouvé dans le DOM');
      return;
    }
    
    // Vider le conteneur de notifications
    $notificationsContainer.empty();
    
    let unreadCount = 0;
    
    // Parcourir toutes les notifications
    snapshot.forEach((doc) => {
      const notification = doc.data();
      const notifId = doc.id;
      
      console.log(`📝 Notification trouvée: ${notifId}`, notification);
      
      // Compter les notifications non lues
      if (!notification.read) {
        unreadCount++;
      }
      
      // Ajouter la notification au conteneur
      const $notificationElement = createNotificationElement(notifId, notification);
      $notificationsContainer.append($notificationElement);
      
      // Si c'est une nouvelle notification non lue, afficher un toast standalone
      if (!notification.read && !processedToasts.has(notifId)) {
        processedToasts.add(notifId);
        showStandaloneToast({ id: notifId, ...notification });
      }
    });
    
    console.log(`🔔 ${unreadCount} notifications non lues`);
    
    // Mettre à jour le compteur de notifications
    updateNotificationCounter(unreadCount);
  }, (error) => {
    console.error('❌ Erreur lors de l\'écoute des notifications:', error);
  });
}
function updateNotificationCounter(count) {
  const $counter = $('#notificationCounter');
  
  if (count > 0) {
    if ($counter.length === 0) {
      // Créer le compteur s'il n'existe pas
      $('#navAccount').prepend(`<div id="notificationCounter">${count}</div>`);
    } else {
      // Mettre à jour le compteur existant
      $counter.text(count).show();
    }
  } else {
    // Cacher le compteur s'il n'y a pas de notifications
    if ($counter.length > 0) {
      $counter.hide();
    }
  }
}
function createNotificationElement(notifId, notification) {
  const timestamp = new Date(notification.timestamp);
  const formattedTime = formatNotificationTime(timestamp);
  const isRead = notification.read;
  const statusClass = notification.status || 'info';
  
  return $(`
    <div class="toast-notification ${statusClass} ${isRead ? 'read' : ''}" data-id="${notifId}" data-campaign-id="${notification.campaignId || ''}">
      <div class="toast-header">
        <strong>${getNotificationTitle(notification)}</strong>
        <div class="notification-actions">
          <button class="toast-delete">🗑️</button>
          <button class="toast-close">×</button>
        </div>
      </div>
      <div class="toast-body">
        <p>${notification.message}</p>
        <small>${formattedTime}</small>
      </div>
    </div>
  `);
}
function getNotificationTitle(notification) {
  const typeMap = {
    'campaign_update': 'Mise à jour de campagne',
    'smartlead_sent': 'Leads envoyés à SmartLead',
    'smartlead_error': 'Erreur SmartLead',
    'blacklist_blocked': 'Blacklist active',
    'process_error': 'Erreur de traitement'
  };
  
  return typeMap[notification.type] || 'Notification';
}
function formatNotificationTime(timestamp) {
  const now = new Date();
  const diff = Math.floor((now - timestamp) / 1000); // Différence en secondes
  
  if (diff < 60) {
    return 'À l\'instant';
  } else if (diff < 3600) {
    const minutes = Math.floor(diff / 60);
    return `Il y a ${minutes} min${minutes > 1 ? 's' : ''}`;
  } else if (diff < 86400) {
    const hours = Math.floor(diff / 3600);
    return `Il y a ${hours} h${hours > 1 ? 's' : ''}`;
  } else {
    const days = Math.floor(diff / 86400);
    return `Il y a ${days} jour${days > 1 ? 's' : ''}`;
  }
}
async function markNotificationAsRead(notificationId) {
  try {
    console.log(`📖 Marquage de la notification ${notificationId} comme lue`);
    const notificationRef = doc(db, 'notifications', notificationId);
    await updateDoc(notificationRef, { read: true });
    console.log(`✅ Notification ${notificationId} marquée comme lue`);
    
    // Ajouter la classe read à l'élément correspondant
    $(`.toast-notification[data-id="${notificationId}"]`).addClass('read');
  } catch (error) {
    console.error('❌ Erreur lors du marquage de la notification comme lue:', error);
  }
}
async function deleteNotification(notificationId) {
  try {
    // Demander confirmation à l'utilisateur avant de supprimer
    if (confirm('Êtes-vous sûr de vouloir supprimer cette notification ?')) {
      console.log(`🗑️ Suppression de la notification ${notificationId}`);
      
      // Référence au document de notification
      const notificationRef = doc(db, 'notifications', notificationId);
      
      // Optimisation: utiliser un batch pour combiner les opérations et réduire les écritures
      const batch = writeBatch(db);
      batch.update(notificationRef, { 
        read: true,
        deleted: true,
        deletedAt: new Date().toISOString() // Ajout d'un timestamp de suppression pour traçabilité
      });
      
      // Exécuter le batch
      await batch.commit();
      console.log(`✅ Notification ${notificationId} supprimée`);
      
      // Animation de suppression de l'élément du DOM
      $(`.toast-notification[data-id="${notificationId}"]`).fadeOut(300, function() {
        $(this).remove();
        
        // Mettre à jour le compteur de notifications après suppression
        const unreadCount = $('#notificationsContainer .toast-notification:not(.read)').length;
        updateNotificationCounter(unreadCount);
      });
    }
  } catch (error) {
    console.error('❌ Erreur lors de la suppression de la notification:', error);
    alert('Une erreur est survenue lors de la suppression de la notification.');
  }
}
// Fonction pour afficher un toast de notification standalone
function showStandaloneToast(notification) {
  console.log('🔔 Affichage du toast standalone pour la notification:', notification);
  
  // Supprimer les anciens toasts si nécessaire
  if ($('.toast-notification.standalone').length > 2) {
    $('.toast-notification.standalone').first().remove();
  }
  
  // Formater la date pour l'affichage
  const timestamp = new Date(notification.timestamp);
  const formattedTime = formatNotificationTime(timestamp);
  
  // Créer le toast
  const statusClass = notification.status || 'info';
  const toast = $(`
    <div class="toast-notification standalone ${statusClass}" data-id="${notification.id}" data-campaign-id="${notification.campaignId || ''}">
      <div class="toast-header">
        <strong>${getNotificationTitle(notification)}</strong>
        <button class="toast-close">×</button>
      </div>
      <div class="toast-body">
        <p>${notification.message}</p>
        <small>${formattedTime}</small>
      </div>
    </div>
  `);
  
  // Ajouter au body et afficher
  $('body').append(toast);
  setTimeout(() => {
    toast.addClass('show');
  }, 10);
  
  // Fermeture au clic
  toast.find('.toast-close').on('click', function() {
    toast.removeClass('show');
    setTimeout(() => {
      toast.remove();
    }, 300);
  });
  
  // Auto-fermeture après 8 secondes
  setTimeout(() => {
    if (toast.length) {
      toast.removeClass('show');
      setTimeout(() => {
        toast.remove();
      }, 300);
    }
  }, 8000);
  
  // Marquer comme lu et rediriger au clic sur le toast
  toast.on('click', function(e) {
    if (!$(e.target).hasClass('toast-close')) {
      markNotificationAsRead(notification.id);
      if (notification.campaignId) {
        window.location.href = `/campaign.html?id=${notification.campaignId}`;
      } else {
        toast.removeClass('show');
        setTimeout(() => {
          toast.remove();
        }, 300);
      }
    }
  });
}
// Déléguer les événements pour les notifications
$(document).on('click', '.toast-notification:not(.standalone)', function(e) {
  if (!$(e.target).hasClass('toast-close') && !$(e.target).hasClass('toast-delete')) {
    const notifId = $(this).data('id');
    console.log(`🖱️ Clic sur la notification ${notifId}`);
    markNotificationAsRead(notifId);
    
    const campaignId = $(this).data('campaign-id');
    if (campaignId) {
      window.location.href = `/campaign.html?id=${campaignId}`;
    }
  }
});
$(document).on('click', '.toast-close', function(e) {
  e.stopPropagation();
  const $notification = $(this).closest('.toast-notification');
  const notifId = $notification.data('id');
  console.log(`🖱️ Clic sur fermer pour la notification ${notifId}`);
  markNotificationAsRead(notifId);
  
  if ($notification.hasClass('standalone')) {
    $notification.removeClass('show');
    setTimeout(() => {
      $notification.remove();
    }, 300);
  }
});
$(document).on('click', '.toast-delete', function(e) {
  e.stopPropagation();
  const $notification = $(this).closest('.toast-notification');
  const notifId = $notification.data('id');
  console.log(`🖱️ Clic sur supprimer pour la notification ${notifId}`);
  deleteNotification(notifId);
});
**/

// Ajout d'un gestionnaire pour afficher le modal des notifications
$(document).on('click', '#notificationCounter, #dots', function(e) {
  e.stopPropagation();
  console.log('🖱️ Clic sur le compteur de notifications ou les points');
  $('#modalAccount').toggleClass('active');
});
// Cacher le modal quand on clique ailleurs
$(document).on('click', function(e) {
  if (!$(e.target).closest('#modalAccount, #notificationCounter, #dots').length) {
    $('#modalAccount').removeClass('active');
  }
});